<template>
    <div class="actions-menu-item" @click="execute" :disabled="disabled">
        <i :class="iconClass" />
        <span>{{ label }}</span>
    </div>
</template>
<script>
export default {
    props: {
        icon: String,
        action: {
            type: Function,
            default: () => {}, //For JQuery powered buttons
        },
        label: String,
        disabled: {
            type: Boolean,
            default: false,
        },
        v4: {
            type: Boolean,
            default: false,
        },
        v5style: {
            type: String,
            default: 'far',
        },
    },
    methods: {
        execute() {
            if (!this.disabled) {
                this.action();
            }
        },
    },
    computed: {
        iconClass() {
            if (this.v4) {
                const className = 'fa-' + this.icon;
                const classes = {
                    fa: true,
                };
                classes[className] = true;
                return classes;
            }
            const className = 'fa-' + this.icon;
            const classes = {};
            classes[this.v5style] = true;
            classes[className] = true;
            return classes;
        },
    },
};
</script>
